import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import EditableImage from '../components/EditableImage';
import { useCMS } from '../context/CMSContext';
import { HomeIntroGate } from '../components/EntryAnimation';

const DEFAULT_HERO = 'https://customer-assets.emergentagent.com/job_preview-share-5/artifacts/99ojz4fg_1000149292.jpg';

const ShopPage = () => {
  const { products } = useCMS();
  const location = useLocation();
  const isHome = location.pathname === '/';

  // Sort by sort_order then name (stable order set by admin)
  const sorted = useMemo(() => {
    return [...products].sort((a, b) => {
      const ao = a.sort_order ?? 999;
      const bo = b.sort_order ?? 999;
      if (ao !== bo) return ao - bo;
      return (a.name || '').localeCompare(b.name || '');
    });
  }, [products]);

  return (
    <>
      {isHome && <HomeIntroGate />}

      {isHome && (
        <section className="w-full bg-slate-50">
          <EditableImage
            k="home.hero_banner_image"
            src={DEFAULT_HERO}
            alt="FAT BUSTERS"
            className="block w-full h-auto max-h-[60vh] object-cover object-center"
          />
        </section>
      )}

      <main className="max-w-7xl mx-auto px-5 sm:px-6 py-10 sm:py-12">
        {sorted.length === 0 ? (
          <div className="text-center text-slate-500 py-16">No products yet.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {sorted.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </main>
    </>
  );
};

export default ShopPage;
